<template>
  <div>
    <el-button @click="$router.back()" style="margin-bottom:16px;">← 返回</el-button>
    <h2>账户详情</h2>

    <el-card class="info-card" v-if="detail">
      <el-descriptions :column="3" border>
        <el-descriptions-item label="账户名称">{{ detail.accountName }}</el-descriptions-item>
        <el-descriptions-item label="账户ID">{{ detail.accountId }}</el-descriptions-item>
        <el-descriptions-item label="统计月份">{{ detail.statMonth }}</el-descriptions-item>
        <el-descriptions-item label="绑定设备数">{{ detail.bindDeviceCount }}</el-descriptions-item>
        <el-descriptions-item label="共享设备数">{{ detail.sharedDeviceCount }}</el-descriptions-item>
      </el-descriptions>
    </el-card>

    <el-row :gutter="16" style="margin:16px 0;" v-if="detail">
      <el-col :span="6">
        <el-card shadow="hover" class="stat-card">
          <div class="stat-value">{{ detail.totalPurchaseBottles }}</div>
          <div class="stat-label">采购瓶数</div>
        </el-card>
      </el-col>
      <el-col :span="6">
        <el-card shadow="hover" class="stat-card">
          <div class="stat-value">{{ detail.totalTheoryTestTimes }}</div>
          <div class="stat-label">理论检测次数</div>
        </el-card>
      </el-col>
      <el-col :span="6">
        <el-card shadow="hover" class="stat-card">
          <div class="stat-value">{{ detail.totalActualTestTimes }}</div>
          <div class="stat-label">实际检测次数</div>
        </el-card>
      </el-col>
      <el-col :span="6">
        <el-card shadow="hover" class="stat-card">
          <div class="stat-value" :style="{ color: getUsageRateColor(detail.totalUsageRate) }">
            {{ detail.totalUsageRate != null ? detail.totalUsageRate + '%' : '-' }}
          </div>
          <div class="stat-label">使用率</div>
        </el-card>
      </el-col>
    </el-row>

    <h3>试剂使用明细</h3>
    <el-table :data="detail?.reagentItems || []" border style="width:100%;">
      <el-table-column prop="reagentName" label="试剂名称" min-width="120" />
      <el-table-column prop="standardTestTimes" label="单瓶理论检测次数" width="130" align="center" />
      <el-table-column prop="purchaseBottleCount" label="采购量" width="90" align="center" />
      <el-table-column prop="theoryTestTimes" label="理论检测次数" width="110" align="center" />
      <el-table-column prop="actualTestTimes" label="实际检测次数" width="110" align="center" />
      <el-table-column label="使用率" width="90" align="center">
        <template v-slot="scope">
          <span :style="{ color: getUsageRateColor(scope.row.usageRate) }">
            {{ scope.row.usageRate != null ? scope.row.usageRate + '%' : '-' }}
          </span>
        </template>
      </el-table-column>
      <el-table-column label="风险等级" width="90" align="center">
        <template v-slot="scope">
          <el-tag :type="getRiskTagType(scope.row.riskLevel)" size="small">{{ scope.row.riskText }}</el-tag>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import { getAccountDetail } from "@/api/reagentMonitor";

export default {
  data() {
    return {
      detail: null,
    };
  },
  created() {
    const accountId = this.$route.params.accountId;
    if (accountId) {
      this.loadDetail(accountId);
    }
  },
  methods: {
    async loadDetail(accountId) {
      try {
        const now = new Date();
        const month = `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, '0')}`;
        const res = await getAccountDetail({ accountId, startMonth: month, endMonth: month });
        if (res.code === 200) {
          this.detail = res.data;
        }
      } catch (e) { console.error(e); }
    },
    getUsageRateColor(rate) {
      if (rate == null) return "#909399";
      if (rate >= 100) return "#F56C6C";
      if (rate >= 50) return "#E6A23C";
      return "#67C23A";
    },
    getRiskTagType(level) {
      if (level === "HIGH") return "danger";
      if (level === "MEDIUM") return "warning";
      return "success";
    },
  },
};
</script>

<style scoped>
.info-card { margin-bottom: 16px; }
.stat-card { text-align: center; padding: 10px 0; }
.stat-value { font-size: 28px; font-weight: bold; color: #303133; }
.stat-label { font-size: 14px; color: #909399; margin-top: 4px; }
</style>
